import { FC, PropsWithChildren, useEffect } from "react";
import { default as profileService } from "./services/profile";
import { actions as profileActions } from "./slices/profile";
import { useAppDispatch, useAppSelector } from "@/hooks";

type ProfileProviderProps = PropsWithChildren;

const ProfileProvider: FC<ProfileProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(state => state.auth?.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;

    dispatch(profileActions.fetchProfileRequested());

    profileService.getProfileData()
      .then(response => {
        dispatch(profileActions.profileReceived(response));
      })
      .catch(_err => {
        dispatch(profileActions.receiveProfileError());
      });
  }, [isAuthenticated, dispatch]);

  return children;
};

export default ProfileProvider;
